

export const options = [
  { label: 'Em estoque', value: 'in_stock' },
  { label: 'Associado', value: 'associated' },
  { label: 'Ativo', value: 'active' },
  { label: 'Bloqueado', value: 'blocked' },
]

export const optionsValues = options.reduce<Record<string, string>>((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});


